// Combined Menu functionality
(function() {
    'use strict';

    // Track if menu is already initialized
    let isMenuInitialized = false;
    
    // Store the original width to detect actual resizes
    let lastWindowWidth = window.innerWidth;
    
    // Main function to handle all menu functionality
    function initializeMenu() {
        // Don't reinitialize on page navigation if width is the same
        if (isMenuInitialized && window.innerWidth === lastWindowWidth) {
            return;
        }
        
        // Update width tracker
        lastWindowWidth = window.innerWidth;
        
        // First, handle the dropdowns for submenu items
        setupDropdownMenus();
        
        // Then, handle the responsive behavior (More menu)
        setupResponsiveDropdown();
        
        // Mark as initialized
        isMenuInitialized = true;
    }
    
    function setupDropdownMenus() {
        const navItems = document.querySelectorAll('.gh-head-menu li');
        const mainMenuItems = [];
        const subMenus = new Map();

        // Build menu structure: "-" items are children of the previous top-level
        // item, "--" items are grandchildren of the previous "-" item
        navItems.forEach((item) => {
            if (item.closest('.dropdown')) return; // already nested
            const link = item.querySelector('a');
            if (!link) return; // Skip items without a link

            const dashes = (link.textContent.trim().match(/^-+/) || [''])[0].length;
            if (dashes === 0) {
                mainMenuItems.push(item);
                return;
            }

            const parent = mainMenuItems[mainMenuItems.length - 1];
            if (!parent) return;
            if (!subMenus.has(parent)) subMenus.set(parent, []);
            const entries = subMenus.get(parent);
            if (dashes >= 2 && entries.length) {
                entries[entries.length - 1].subs.push(item);
            } else {
                entries.push({ item, subs: [] });
            }
        });

        const cleanLabel = (li) => {
            const link = li.querySelector('a');
            // Remove the leading dashes and trim whitespace
            if (link) link.textContent = link.textContent.replace(/^\s*-+\s*/, '').trim();
        };

        // Apply dropdowns
        mainMenuItems.forEach((item) => {
            const entries = subMenus.get(item);
            if (entries) {
                // Check if the dropdown and caret icon already exist
                if (!item.querySelector('.dropdown') && !item.querySelector('.caret-down')) {
                    const dropdown = document.createElement('ul');
                    dropdown.className = 'dropdown';

                    entries.forEach(({ item: child, subs }) => {
                        cleanLabel(child);

                        if (subs.length) {
                            const submenu = document.createElement('ul');
                            submenu.className = 'dropdown submenu';
                            subs.forEach((grandchild) => {
                                cleanLabel(grandchild);
                                submenu.appendChild(grandchild);
                            });

                            // Toggle (caret) for touch, keyboard and mobile; clicks are
                            // handled by the delegated listener below so they survive
                            // the nav being rebuilt on resize
                            const toggle = document.createElement('button');
                            toggle.type = 'button';
                            toggle.className = 'submenu-toggle';
                            toggle.setAttribute('aria-label', 'Show submenu');
                            toggle.setAttribute('aria-expanded', 'false');
                            toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" fill="currentColor" viewBox="0 0 256 256" class="icon caret-side"><rect width="256" height="256" fill="none"></rect><polyline points="96 48 176 128 96 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></polyline></svg>';

                            child.classList.add('has-submenu');
                            child.appendChild(toggle);
                            child.appendChild(submenu);
                        }

                        dropdown.appendChild(child);
                    });

                    item.classList.add('has-dropdown');

                    // Add caret-down icon
                    const caretIcon = document.createRange().createContextualFragment(`
                        <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" fill="currentColor" viewBox="0 0 256 256" class="icon caret-down">
                            <rect width="256" height="256" fill="none"></rect><polyline points="208 96 128 176 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></polyline>
                        </svg>
                    `);
                    item.querySelector('a').appendChild(caretIcon);

                    item.appendChild(dropdown);

                    // Add hover event listeners
                    item.addEventListener('mouseenter', () => {
                        item.classList.add('show-dropdown');
                    });

                    item.addEventListener('mouseleave', () => {
                        item.classList.remove('show-dropdown');
                    });
                }
            }
        });
    }

    // Delegated clicks: submenu toggle buttons, and "#" placeholder parent links
    document.addEventListener('click', function(e) {
        const toggle = e.target.closest && e.target.closest('.submenu-toggle');
        if (toggle) {
            e.preventDefault();
            e.stopPropagation();
            const item = toggle.closest('li');
            const open = item.classList.toggle('submenu-open');
            toggle.setAttribute('aria-expanded', String(open));
            toggle.setAttribute('aria-label', open ? 'Hide submenu' : 'Show submenu');
            return;
        }
        const parentLink = e.target.closest && e.target.closest('.gh-head-menu li.has-dropdown > a');
        if (parentLink) {
            const href = parentLink.getAttribute('href') || '';
            if (href === '#' || href.endsWith('/#')) e.preventDefault();
        }
    });

    function setupResponsiveDropdown() {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const menu = document.querySelector('.gh-head-menu');
        const nav = menu?.querySelector('.nav-new');
        if (!nav) return;
        
        // Get a fresh state of the nav
        if (!window.originalNavHTML) {
            // Save the original structure once
            window.originalNavHTML = nav.innerHTML.trim();
        } else {
            // Reset to original state for calculation
            nav.innerHTML = window.originalNavHTML;
        }
        
        // Handle mobile-specific styling
        if (mediaQuery.matches) {
            const items = nav.querySelectorAll('li');
            items.forEach(function (item, index) {
                item.style.transitionDelay = `${0.03 * (index + 1)}s`;
            });
            return;
        }
        
        // For desktop, create the responsive "More" dropdown if needed
        const submenuItems = [];
        
        // Store the current width for later comparison
        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }
        
        if (!submenuItems.length) {
            document.body.classList.add('is-dropdown-loaded');
            return;
        }
        
        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'nav-more-toggle gh-icon-btn');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';
        
        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');
        
        if (submenuItems.length >= 10) {
            document.body.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            document.body.classList.remove('is-dropdown-mega');
        }
        
        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });
        
        toggle.appendChild(wrapper);
        nav.appendChild(toggle);
        
        document.body.classList.add('is-dropdown-loaded');
        
        // Set up toggle for the "More" dropdown
        toggle.addEventListener('click', function(e) {
            document.body.classList.toggle('is-dropdown-open');
            e.stopPropagation();
        });
        
        document.addEventListener('click', function(e) {
            if (!toggle.contains(e.target)) {
                document.body.classList.remove('is-dropdown-open');
            }
        });
    }
    
    // Initialize once on page load
    initializeMenu();
    
    // Re-initialize on DOM ready as fallback
    document.addEventListener('DOMContentLoaded', initializeMenu);
    
    // Handle window resize properly
    let resizeTimer;
    window.addEventListener('resize', function() {
        // Mobile browsers fire resize when the address bar shows/hides; the menu
        // only needs rebuilding when the width changes (it would collapse any
        // open submenu)
        if (window.innerWidth === lastWindowWidth) return;
        // Mark as not initialized to force recalculation
        isMenuInitialized = false;
        // Use debouncing to avoid excessive calculations
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initializeMenu, 100);
    });
    
    // Set up for link navigation - prevent flicker
    document.addEventListener('click', function(e) {
        if (e.target.tagName === 'A' && !e.target.classList.contains('nav-more-toggle')) {
            // Don't reset menu initialization state during navigation
            isMenuInitialized = true;
        }
    });
})(); 